module.exports = __webpack_public_path__ + "img/highlight4.db86cbec.png";